import classNames from "classnames";
import { Icon } from "@circle-react/components/shared/Icon";
import type { IconType } from "@circle-react/components/shared/Icon";

interface NavButtonProps {
  disabled?: boolean;
  iconType: IconType;
  onClick: () => void;
}

export const NavButton = ({
  onClick,
  iconType,
  disabled,
  ...otherProps
}: NavButtonProps) => (
  <button
    type="button"
    className={classNames(
      "text-dark border-primary hover:bg-tertiary flex items-center space-x-3 rounded-md border px-[7px] py-[6px] transition-colors duration-150 ease-in-out",
      {
        "pointer-events-none opacity-25": disabled,
      },
    )}
    onClick={onClick}
    {...otherProps}
  >
    <Icon type={iconType} size={16} />
  </button>
);
